import { setUserData } from 'auth/store/actions/user.actions';
import axios from 'axios';
import { fuseAdminNavigationConfig } from 'fuse-configs/fuseAdminNavigationConfig';
import { fuseIMCAdminNavigationConfig } from 'fuse-configs/fuseIMCAdminNavigationConfig';
import { fuseNavigationConfig } from 'fuse-configs/fuseNavigationConfig';
import { fuseSupervisorNavigationConfig } from 'fuse-configs/fuseSupervisorNavigationConfig';
import { fuseUserNavigationConfig } from 'fuse-configs/fuseUserNavigationConfig';
import { setNavigation } from 'store/actions/fuse/navigation.actions';

export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export function submitLogin({ username, password }) {
    /* const request = axios.get('/api/auth', {
        data: {
            username,
            password
        }
    }); */

    //const request = axios.post(window.authServer+'/access/login',
    const request = axios.post(window.authServer + '/access/login',

        {
            username: username,
            password: password
        }
    );


    /* const user = {
        //role: moduleNewArray,


            password: "admin",
            role: "admin",
            data: {
                'name': 'Abbott',
                'lastName': 'Keitch',
                'avatar': 'assets/images/avatars/Abbott.jpg',
                settings: {
                    layout: {
                        navbar: 'left',
                        navbarFolded: true,
                        toolbar: 'below',
                        footer: 'below',
                        mode: 'fullwidth'
                    },
                    customScrollbars: true,
                    theme: 'defaultDark',
                    navbarTheme: 'defaultDark',
                    toolbarTheme: 'defaultDark',
                    footerTheme: 'defaultDark'
                }


            }

    }; */

    return (dispatch) =>
        request.then((response) => {
            console.log(response.data);
            if (!response.data.error) {
                axios.post(window.hrmServer + '/hr/getEmployeeActiveProfile',
                    {
                        id: response.data.employeeId
                    }
                ).then((response2) => {
                    if (response2.data.success) {
                        response.data.latestEmployeeId = response2.data.id
                    }

                    dispatch(setUserData(response.data));
                    if (response.data.role == 'admin') {
                        if (window.env === "IMC") {
                            dispatch(setNavigation(fuseIMCAdminNavigationConfig));
                        } else {
                            dispatch(setNavigation(fuseAdminNavigationConfig));
                        }
                    }
                    else if (response.data.role == 'supervisor') {
                        dispatch(setNavigation(fuseSupervisorNavigationConfig));
                    }
                    else if (response.data.role == 'user') {
                        dispatch(setNavigation(fuseUserNavigationConfig));
                    } else {
                        dispatch(setNavigation(fuseNavigationConfig));
                    }

                    return dispatch({
                        type: LOGIN_SUCCESS
                    });
                })
                    .catch((error) => {
                        console.log('get latest employee profile id error', error);

                        dispatch(setUserData(response.data));
                        if (response.data.role == 'admin') {
                            if (window.env === "IMC") {
                                dispatch(setNavigation(fuseIMCAdminNavigationConfig));
                            } else {
                                dispatch(setNavigation(fuseAdminNavigationConfig));
                            }
                        }
                        else if (response.data.role == 'supervisor') {
                            dispatch(setNavigation(fuseSupervisorNavigationConfig));
                        }
                        else if (response.data.role == 'user') {
                            dispatch(setNavigation(fuseUserNavigationConfig));
                        } else {
                            dispatch(setNavigation(fuseNavigationConfig));
                        }

                        return dispatch({
                            type: LOGIN_SUCCESS
                        });
                    });




            }
            else {
                console.log('error', response.data.error);
                return dispatch({
                    type: LOGIN_ERROR,
                    payload: response.data.error
                });
            }
        })
            .catch((error) => {

                // Error
                if (error && typeof error === 'undefined') {

                    //console.log('login axios error block', error);
                    return dispatch({
                        type: LOGIN_ERROR,
                        payload: 'Server Error'
                    });

                }
                else if (error) {
                    //console.log('error');
                    return dispatch({
                        type: LOGIN_ERROR,
                        payload: 'Auth server busy or not working'
                    });
                }


            });
}



// WEBPACK FOOTER //
// ./src/auth/store/actions/login.actions.js